import { LanguageProps } from "@lib/types/Apps";

const languageData: LanguageProps[] = [
  {
    languageId: "english",
    locale: "en",
    name: "English",
  },
  {
    languageId: "turkish",
    locale: "tr",
    name: "Turkish",
  },
];
export default languageData;
